import factory from '@/utils/api/factory';
import request from '@/utils/api/request';
import TENDER_STATUSES from '@/utils/constants/tender-statuses';

export const state = () => ({
  tenders: [],
  nextTendersUrl: null,
  archivedTendersLoaded: false,
  tendersLoading: true,
  moreTendersLoading: false,
  tendersLoadingError: false,
});

export const mutations = {
  setNextUrl(state, value) {
    state.nextTendersUrl = value;
  },
  setTenders(state, tenders) {
    state.tenders = tenders;
  },
  setArchivedTendersLoadedStatus(state, value) {
    state.archivedTendersLoaded = value;
  },
  setTendersLoadingStatus(state, value) {
    state.tendersLoading = value;
  },
  setMoreTendersLoadingStatus(state, value) {
    state.moreTendersLoading = value;
  },
  setAdditionallyTenders(state, tenders) {
    state.archivedTendersLoaded = true;
    state.tenders = [...state.tenders, ...tenders];
  },
  setLoadingError(state, value) {
    state.tendersLoadingError = value;
  },
  setProjectTitle(state, value) {
    state.projectTitle = value;
  },
};

export const actions = {
  async loadTenders({ commit }, { projectId, status, additionally }) {
    commit('setLoadingError', false);
    if (additionally) {
      commit('setMoreTendersLoadingStatus', true);
    } else {
      commit('setTendersLoadingStatus', true);
      commit('setTenders', []);
      commit('setArchivedTendersLoadedStatus', false);
    }
    const requestStatus = status || TENDER_STATUSES.active;
    try {
      const { data } = await factory('tenders').index({
        project_id: projectId,
        status: requestStatus,
      });
      if (additionally) {
        commit('setAdditionallyTenders', data.results);
      } else {
        commit('setTenders', data.results);
      }
      commit('setNextUrl', data.next);
    } catch (e) {
      commit('setLoadingError', true);
      console.error(e);
    }
    if (additionally) {
      commit('setMoreTendersLoadingStatus', false);
    } else {
      commit('setTendersLoadingStatus', false);
    }
  },
  async uploadMoreTenders({ commit, state }) {
    if (state.nextTendersUrl)
      try {
        const { data } = await request.get(state.nextTendersUrl + 'lalla');
        commit('setTenders', [...state.tenders, ...data.results]);
        commit('setNextUrl', data.next);
      } catch (e) {
        commit('setLoadingError', true);
        console.error(e);
      }
  },
};

export default { namespaced: true, state, mutations, actions };
